import sdl from '@jds/react-generated-sdl/JDSModalMobile';
import type { JDSModalMobileProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, ModalProps } from '../logic';

const Component = (props: ModalProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    kind = 'dialog',
    size = 'medium',
    headerAlignment = 'left',
    isCloseable = true,
    close = true,
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { kind, size, headerAlignment, isCloseable, close, ...rest },
    'JDSModalMobile',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const Modal = withLogic(Component) as React.FC<ModalProps> & {
  slotName?: string;
};

Modal.displayName = 'Modal';
Modal.slotName = 'jds_modal_mobile';

export { Modal, type JDSModalMobileProps };
